import { object, string, boolean, array, type InferType, number } from "yup";

const roomSchema = object({
  adult: number()
    .min(1, "حداقل یک بزرگسال برای هر اتاق الزامی است")
    .required("تعداد بزرگسالان الزامی است"),
  child: array()
    .of(
      string()
        .required("سن هر کودک الزامی است")
        .notOneOf([undefined, null, ""], "لطفاً سن هر کودک را انتخاب کنید"),
    )
    .default([]),
});

export const tourSchema = object()
  .shape({
    date: object({
      depart: string(),
      return: string(),
    })
      .default(undefined)
      .required("تاریخ رفت و برگشت الزامی می باشد"),
    origin: object({
      name: string().required("فیلد رفت الزامی می باشد"),
      id: number().required("فیلد رفت الزامی می باشد"),
      type: string().oneOf(["city", "airport"]),
      code: string().required("فیلد رفت الزامی می باشد"),
    })
      .default(undefined)
      .required("مبدا الزامی می باشد"),
    destination: object({
      name: string().required("فیلد برگشت الزامی می باشد"),
      id: number().required("فیلد برگشت الزامی می باشد"),
      type: string().oneOf(["city", "airport"]),
      code: string().required("فیلد برگشت الزامی می باشد"),
    })
      .default(undefined)
      .required("مقصد الزامی می باشد"),
    rooms: array()
      .of(roomSchema)
      .min(1, "حداقل یک اتاق الزامی است")
      .default([{ adult: 2, child: [] }])
      .required("جزئیات اتاق‌ها الزامی است")
      // Custom test with dynamic messages
      .test(
        "rooms-complete",
        // Default message (will be overridden dynamically)
        "لطفاً اطلاعات اتاق‌ها را کامل کنید",
        function (rooms) {
          if (!rooms || rooms.length === 0) {
            return this.createError({
              message: "حداقل یک اتاق الزامی است",
            });
          }

          for (const room of rooms) {
            // Check adult
            const adultValid =
              typeof room.adult === "number" && room.adult >= 1;
            if (!adultValid) {
              return this.createError({
                message: "حداقل یک بزرگسال برای هر اتاق الزامی است",
              });
            }

            // Check child ages
            const childValid =
              Array.isArray(room.child) &&
              room.child.every(
                (age) => typeof age === "string" && age.trim() !== "",
              );
            if (!childValid) {
              return this.createError({
                message: "لطفاً سن هر کودک را انتخاب کنید",
              });
            }
          }

          return true; // All rooms are valid
        },
      ),
  })
  .test(
    "origin-destination-different",
    "مبدا و مقصد نمی توانند یکسان باشند",
    function (value) {
      const { origin, destination } = value;
      if (origin && destination && origin.name === destination.name) {
        return this.createError({
          path: "destination",
          message: "مبدا و مقصد نمی توانند یکسان باشند",
        });
      }
      return true;
    },
  )
  .required();

export const tourDefaultValue = {
  rooms: [{ adult: 2, child: [] }],
};

export type TourSchema = InferType<typeof tourSchema>;
